import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private inactivityTimer?: any;
  private warningTimer?: any;
  private countdownInterval?: any;

  private readonly MAX_INACTIVE = environment.MAX_INACTIVE_MINUTES * 60 * 1000;
  private readonly WARNING_TIME = environment.WARNING_TIME_SECONDS * 1000;
  public warning$ = new Subject<void>();

  constructor(private authService: AuthService, private router: Router) {
    this.initActivityListeners();
    this.checkIfActiveSession();
  }

  private checkIfActiveSession() {
    const token = this.authService.getToken();
    if (!token) return;
    this.resetTimer();
  }

  private initActivityListeners() {
    const events = ['mousemove', 'keydown'];

    events.forEach((event) =>
      window.addEventListener(event, (e: Event) => {
        if (!this.authService.getToken()) return;

        if (event === 'keydown') {
          const target = e.target as HTMLElement;
          const isInput =
            target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable;

          if (!isInput) return;
        }

        this.resetTimer();
      })
    );
  }

  private resetTimer() {
    clearTimeout(this.inactivityTimer);
    clearTimeout(this.warningTimer);
    clearInterval(this.countdownInterval);

    const remaining = this.MAX_INACTIVE / 1000;
    const start = Date.now();

    this.countdownInterval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - start) / 1000);
      const remainingSec = Math.max(0, remaining - elapsed);
      if (remainingSec % 60 === 0) {
        const remainingMin = Math.ceil(remainingSec / 60);
      }
    }, 1000);

    this.warningTimer = setTimeout(() => {
      this.warning$.next();
    }, this.MAX_INACTIVE - this.WARNING_TIME);

    this.inactivityTimer = setTimeout(() => {
      clearInterval(this.countdownInterval);
      this.authService.clear();
      this.router.navigate(['/']);
    }, this.MAX_INACTIVE);
  }

  public keepAlive() {
    this.resetTimer();
  }
}
